<template>
    <div v-if="this.loaded">
        <button v-if="!buttonClicked" v-on:click="toggleActive" class="image__play-video">
            <span class="visually-hidden">Speel video af</span>
            <Icon name="play" />
        </button>
        <div class="iframe-container" v-if="active">
            <div v-if="this.type == 'youtube'" class="video-container">
                <iframe class="responsive-iframe" :src="getUrl()" title="Popup video" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay" allowfullscreen></iframe>
            </div>
            <div v-else-if="this.type == 'vimeo'" v-html="getVimeoIframe()" class="video-container"></div>
        </div>
    </div>
</template>

<script>
import Icon from './Icon.vue';
import axios from 'axios';

export default {
    name: 'VideoIframe',
    data() {
        return {
            loaded: false,
            active: false,
            vimeoVideo: null,
            buttonClicked: false // Add a flag for button click
        };
    },
    methods: {
        toggleActive: function() {
            this.active = !this.active;
            this.buttonClicked = true; // Set the flag to true when the button is clicked

            if(!this.vimeoVideo && this.type === 'vimeo') {
                this.fetchVimeoVideo();
            }

            // Hide the external div with JavaScript
            const externalImageCover = document.getElementById('externalImageCover');
            if (externalImageCover) {
                externalImageCover.style.display = 'none';
            }
        },
        getUrl() {
            if(this.type === 'youtube') {
                return `${this.url}?enablejsapi=1`;
            }
        },
        getVimeoIframe() {
            if (this.vimeoVideo) {
                return this.vimeoVideo.html;
            }
        },
        fetchVimeoVideo(url) {
            // get vimeo iframe object from the oembed api,
            // https://developer.vimeo.com/api/oembed/videos#embedding-a-video-with-oembed-step-13
            
            axios
                .get(`https://vimeo.com/api/oembed.json?url=${this.url}`)
                .then(response => (this.vimeoVideo = response.data))
        }
    },
    props: ['url', 'type'],
    mounted: function(){
        this.loaded = true;
    },
    components: {
        Icon: Icon
    }
};
</script>

<style lang="scss">
    .video-container {
        display: flex;
        justify-content: center;
        position: relative;
        overflow: hidden;
        width: 100%;
        padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
        iframe {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>